import { FaFacebookF, FaInstagram, FaTiktok } from 'react-icons/fa'
import styles from '@styles/SocialLinks.module.css'
import { AiOutlineFileText } from 'react-icons/ai'

const SocialLinks = () => {
  return (
    <div className={styles.socialLinksContainer}>
      <div className={styles.socialLinks}>
        <a
          href='https://www.facebook.com/profile.php?id=61572480777900'
          className={styles.socialLink}
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Facebook'
        >
          <FaFacebookF />
        </a>
        <a
          href='https://www.instagram.com/optica_natalu?igsh=MWh6ZjA4ejN3eWo0'
          className={styles.socialLink}
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Instagram'
        >
          <FaInstagram />
        </a>
        <a
          href='https://www.tiktok.com/@opticanatalu2?_t=ZS-8tJ74JLH94E&_r=1'
          className={styles.socialLink}
          target='_blank'
          rel='noopener noreferrer'
          aria-label='TikTok'
        >
          <FaTiktok />
        </a>
      </div>
        <div className={styles.termLink}>
          <a
            href='/terminos-y-condiciones'
            className={`${styles.socialLink} ${styles.termsLink}`}
            aria-label='Términos y Condiciones'
          >
            <AiOutlineFileText />
            <span className={styles.termsText}>Términos y Condiciones</span>
          </a>
        </div>
    </div>
  )
}

export default SocialLinks
